import { defineComponent } from "vue";
import { useRegisterTestStore } from "@/store/RegisterTestStore";
import { mapWritableState } from "pinia";
import { Validator } from "@/validator/Validator";
import FloatingCard from "@/components/Shared/RegisterTest/FloatingCard/FloatingCard.vue";
import BaseInput from "@/components/BaseForm/BaseInput/BaseInput.vue";
import BaseSelect from "@/components/BaseForm/BaseSelect/BaseSelect.vue";

export default defineComponent({
  props: {
    active: {
      type: Boolean,
    },
  },
  components: {
    FloatingCard,
    BaseInput,
    BaseSelect,
  },
  data() {
    return {
      msg: false,
      registerTestStore: useRegisterTestStore(),
      requiredFields: ["name", "birthdate", "gender"],
      ageErrorMsg: "O campo aceita apenas datas válidas.",
      genderOptions: [
        { name: "Feminino", value: "female" },
        { name: "Masculino", value: "male" },
        { name: "Prefiro não informar", value: "uninformed" },
      ],
      nameFieldValidations: [
        { validation: 'requiredField', message: 'Campo de preenchimento obrigatório.' },
      ],
      birthDateFieldValidations: [
        { validation: 'requiredField', message: 'Campo de preenchimento obrigatório.' },
        { validation: 'validBirthDate', message: 'O campo aceita apenas data válida.' },
      ],
      genderFieldValidations: [
        { validation: 'requiredField', message: 'Campo de preenchimento obrigatório.' },
      ], 
    };
  },
  computed: {
    ...mapWritableState(useRegisterTestStore, ["canJumpNext"]),
    ...mapWritableState(useRegisterTestStore, ["patient"]),
  },
  watch: {
    patient: {
      handler: function () {
        setTimeout(() => {
          if (this.active) {
            this.canJumpNext = this.isValidForm(false);
          }
        }, 200);
      },
      deep: true,
    },
  },
  methods: {
    ageForm(event: any){
      this.msg = false;

      let data = event.replace(/\//g, "-");
      const data_array = data.split("-");

      if (data_array[0].length != 4) {
        data = data_array[2] + "-" + data_array[1] + "-" + data_array[0];
      }

      const today = new Date();
      const birth = new Date(data);
      let age = today.getFullYear() - birth.getFullYear();
      const month = today.getMonth() - birth.getMonth();
      if (month < 0 || (month === 0 && today.getDate() <= birth.getDate())) age--; 
      if (age < 14) {
        this.msg = true;
      } else {
        this.msg = false;
      }

      if (today.getFullYear() < birth.getFullYear()) {
        this.msg = false;
      }

    },
    errorValidation() {
      this.isValidForm();
    },
    isValidForm(showErrors = true): boolean {
      return Validator.validateForm(this.$refs, showErrors);
    },
    isValidStep(): boolean {
      return this.isValidForm(false);
    },
    setAnimationType(animationName: string) {
      setTimeout(() => {
        const baseModal: any = this.$refs["base-modal"];
        switch (animationName) {
          case "setNextDismissAnimation":
            baseModal.setNextDismissAnimation();
            break;
          case "setNextShowAnimation":
            baseModal.setNextShowAnimation();
            break;
          case "setPreviousDismissAnimation":
            baseModal.setPreviousDismissAnimation();
            break;
          case "setPreviousShowAnimation":
            baseModal.setPreviousShowAnimation();
            break;
        }
      }, 1);
    }
  },
});
